"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        header: {
            display: 'flex',
            alignItems: 'center',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            paddingBottom: theme.spacing(3),
            paddingTop: theme.spacing(3),
        },
        icon: {
            display: 'flex',
            alignItems: 'center',
            marginRight: theme.spacing(1.5),
        },
        title: {
            color: themes_1.materialColors.grey[200],
            flexGrow: 1,
            '& > *': {
                fontWeight: 500,
            },
        },
    });
});
